import React, { useState, useEffect, memo } from 'react';

import '../tourFull.css';

import { Checkbox, Tooltip } from 'antd';

import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import {
  ScenicSvg,
  SeasideSvg,
  StraightSvg,
  TwistedSvg,
  MountainSvg,
} from '../../MainMenu/svg';

import { detectArrowTourType } from '../../../Utility/utility';
import { useTimestamp } from '../../../Utility/Service/keepTimestamp.service';

const [addToProgress, removeFromProgress] = useTimestamp();

let isTypeLoaded = false;
const position = 'top';

const TourTypeFullView = (props) => {
  const { isCreate } = props;

  const { setArrowTourType } = useActions();

  const isEditMode = useSelector((store) => store.tourFullData.isEditMode);

  const arrow_type = useSelector(
    (store) => store.tourFullData.activeMultiPart.arrow_type
  );

  const [state, setState] = useState({
    isSeaside: false,
    isMountain: false,
    isScenic: false,
    isStraight: false,
    isTwisted: false,
    typeNumber: 0,
  });

  const setType = () => {
    const { isScenic, isMountain, isSeaside, isTwisted, isStraight } =
      detectArrowTourType(arrow_type);
    isTypeLoaded = true;
    setState({
      isSeaside,
      isMountain,
      isScenic,
      isStraight,
      isTwisted,
      typeNumber: +arrow_type,
    });
  };

  useEffect(() => {
    if (isCreate !== undefined && !isTypeLoaded && arrow_type > 0) {
      setType();
    }
    return () => {
      isTypeLoaded = false;
    };
  }, [arrow_type]);

  useEffect(() => {
    if (state.typeNumber !== arrow_type && isEditMode) {
      addToProgress();
      const timestamp = removeFromProgress();
      setArrowTourType(state.typeNumber, timestamp);
    }
  }, [state.typeNumber]);

  const getNewType = (num, isSelected) =>
    isSelected ? state.typeNumber - num : state.typeNumber + num;

  const onChange = ({ target }) => {
    const { isSeaside, isMountain, isScenic, isStraight, isTwisted } = state;
    switch (target.value) {
      case '4':
        setState({
          ...state,
          isSeaside: !isSeaside,
          typeNumber: getNewType(4, isSeaside),
        });
        break;

      case '2':
        setState({
          ...state,
          isMountain: !isMountain,
          typeNumber: getNewType(2, isMountain),
        });
        break;

      case '1':
        setState({
          ...state,
          isScenic: !isScenic,
          typeNumber: getNewType(1, isScenic),
        });
        break;

      case '16':
        setState({
          ...state,
          isStraight: !isStraight,
          typeNumber: getNewType(16, isStraight),
        });
        break;

      case '8':
        setState({
          ...state,
          isTwisted: !isTwisted,
          typeNumber: getNewType(8, isTwisted),
        });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div>
        <Checkbox
          checked={state.isSeaside}
          value="4"
          disabled={!isEditMode}
          onChange={onChange}
        >
          <Tooltip
            title={<FormattedMessage id="Seaside" defaultMessage="Seaside" />}
            placement={position}
          >
            <div className={isEditMode ? 'svgHoverTourType' : ''}>
              <SeasideSvg />
            </div>
          </Tooltip>
        </Checkbox>
      </div>
      <div>
        <Checkbox
          checked={state.isMountain}
          value="2"
          disabled={!isEditMode}
          onChange={onChange}
        >
          <Tooltip
            title={<FormattedMessage id="Mountain" defaultMessage="Mountain" />}
            placement={position}
          >
            <div className={isEditMode ? 'svgHoverTourType' : ''}>
              <MountainSvg />
            </div>
          </Tooltip>
        </Checkbox>
      </div>
      <div>
        <Checkbox
          checked={state.isScenic}
          value="1"
          disabled={!isEditMode}
          onChange={onChange}
        >
          <Tooltip
            title={<FormattedMessage id="Scenic" defaultMessage="Scenic" />}
            placement={position}
          >
            <div className={isEditMode ? 'svgHoverTourType' : ''}>
              <ScenicSvg />
            </div>
          </Tooltip>
        </Checkbox>
      </div>
      <div>
        <Checkbox
          checked={state.isStraight}
          value="16"
          disabled={!isEditMode}
          onChange={onChange}
        >
          <Tooltip
            title={<FormattedMessage id="Straight" defaultMessage="Straight" />}
            placement={position}
          >
            <div className={isEditMode ? 'svgHoverTourType' : ''}>
              <StraightSvg />
            </div>
          </Tooltip>
        </Checkbox>
      </div>
      <div>
        <Checkbox
          checked={state.isTwisted}
          value="8"
          disabled={!isEditMode}
          onChange={onChange}
        >
          <Tooltip
            title={<FormattedMessage id="Twisted" defaultMessage="Twisted" />}
            placement={position}
          >
            <div className={isEditMode ? 'svgHoverTourType' : ''}>
              <TwistedSvg />
            </div>
          </Tooltip>
        </Checkbox>
      </div>
    </>
  );
};

export default memo(TourTypeFullView);
